// Chave publica da KLIPY (GIFs e figurinhas). Gravada pelo 35-SERVIDOR-0.51-E-GIFS.bat.
// So busca GIFs, nao da acesso a nada seu.
export const KLIPY = 'GyTBQ0YGWB9im8PItmIM5yjXIMAWptvqM0J9AONwGK77l9QcEOOCMU73iumWfYBr';
